import { store } from "~/index";
import routes from "~/utils/routes";

const routesByNames: any = Object.values(routes).reduce((acc, route) => {
  return { ...acc, [route.PATHNAME]: route };
}, {});

const getPageTitle = () => {
  return routesByNames[window.location.pathname]
    ? routesByNames[window.location.pathname].AMPLITUDE_TITLE
    : routesByNames["*"].AMPLITUDE_TITLE;
};

export const logEvent = (event: string, props = {}) => {
  if (!(window as any).amplitude) {
    return console.warn("Приложение не видит Амплитуду");
  }

  (window as any).amplitude.logEvent(event, {
    Часть: "Прод",
    Регион: store.cityStore.currentCity?.area_name,
    Город: store.cityStore.currentCity?.name,
    ...(!event.includes("Э/ ")
      ? {
          "Страница пользователя": getPageTitle(),
        }
      : {}),
    ...(store.patientStore.currentPatient
      ? {
          "Ид пациента": store.patientStore.currentPatient.idUserData,
        }
      : {}),
    ...(store.hospitalStore.currentHospital
      ? {
          "Название больницы":
            store.hospitalStore.currentHospital.organisationName,
        }
      : {}),
    ...(store.specialityStore.currentSpeciality
      ? {
          "Название специальности":
            store.specialityStore.currentSpeciality.name,
        }
      : {}),
    ...(store.specialistStore.currentSpecialist
      ? { "ФИО Врача": store.specialistStore.currentSpecialist.lname }
      : {}),
    ...(store.hospitalStore.currentHospital ? { Тип: "ГОС" } : {}),
    ...props,
  });
};
